module.exports = __webpack_public_path__ + "img/0x38a2aace91f92b979207c0dd50a857c117d4785b.5df836db.png";